var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDelayIcon(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 4a8 8 0 00-8 8h1c0-1.819.809-3.449 2.088-4.549l3.052 3.815a2 2 0 101.126-1.126L3.5 7.127A6 6 0 0113.001 12h3a8 8 0 00-8-8z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelayIcon);
export default __webpack_public_path__ + "static/media/delay-icon.91399b7a9701a0fd8b5c98fbd8e50fa4.svg";
export { ForwardRef as ReactComponent };